









































































import ForgetPasswordComp from './components/ForgetPasswordComp.vue';
import LoginFormComp from './components/LoginFormComp.vue';
import LoginUpgradeDialog from './components/LoginUpgradeDialog.vue';
import PlatformNoticeDialog from './components/PlatformNoticeDialog.vue';
import RegisterFormComp from './components/RegisterFormComp.vue';

import { Component, Ref, Vue } from 'vue-property-decorator';
import { Form as ElForm } from 'element-ui';
import { getPhoneRegionApi } from '@/api/login';
import { redirectToGear3Login } from '@/utils/gear3Redirect';
// import { getGear3LoginUrl } from '@/utils/gear3Redirect';
import {
  getLoginUpgradeNoticeKey,
  setLoginUpgradeNoticeKey,
} from '@/utils/storage_session';

@Component({
  name: 'login',
  components: {
    LoginFormComp,
    LoginUpgradeDialog,
    PlatformNoticeDialog,
    RegisterFormComp,
    ForgetPasswordComp,
  },
})
export default class extends Vue {
  @Ref('login-form') public loginForm!: ElForm;
  @Ref('register-form') public registerForm!: ElForm;
  @Ref('loginVideoRef') public loginVideoRef!: HTMLVideoElement;
  public loginVideo: any = 'https://get-bms-images-prd-1304425382.cos.accelerate.myqcloud.com/gear/login-video.mp4';
  public readonly videoPoster = require('@/assets/image/common/video-img.png');
  public exflag = false; // 登录注册之间切换标记
  public dialogVisible = false;
  public platformNoticeVisible = false;
  public platformNoticeMessage = '';
  public platformUpgradeVisible = false;
  public phoneRegionOptions: any = [];
  public countryOptions: any = [];
  public shouldLoadVideo = false;
  public videoPlayTimer: number | null = null;

  public mounted() {
    const query = this.$route.query;
    if (query && query.invitcode) {
      this.handleSignUp();
    }
    this.handlePlatformTransfer();
    this.handlePlatformUpgradeNotice();
    this.getPhoneRegion();
    this.delayPlayVideo();
  }

  public beforeDestroy() {
    if (this.videoPlayTimer !== null) {
      window.clearTimeout(this.videoPlayTimer);
      this.videoPlayTimer = null;
    }
  }

  public delayPlayVideo() {
    this.videoPlayTimer = window.setTimeout(() => {
      this.shouldLoadVideo = true;
      this.$nextTick(() => {
        const videoEl = this.loginVideoRef;
        if (videoEl) {
          videoEl.load();
          videoEl.play().catch(() => {
            //
          });
        }
      });
    }, 1000);
  }

  public handlePlatformTransfer() {
    const query: any = this.$route.query;
    const encodedUsername = query.username;
    const shouldShowNotice = query.showUpgradeNotice === '1';
    if (!encodedUsername) {
      return;
    }

    try {
      const username = decodeURIComponent(escape(window.atob(decodeURIComponent(encodedUsername))));
      const loginFormComp: any = this.$refs['login-form'];
      if (loginFormComp && username) {
        loginFormComp.loginFormData.username = username;
      }
      if (shouldShowNotice) {
        this.platformNoticeMessage = this.$t('login.platformLoginNotice') as string;
        this.platformNoticeVisible = true;
      }
    } catch (error) {
      console.error('Failed to decode transferred username', error);
    }
  }

  public handleSignIn() {
    this.exflag = false;
    if (this.registerForm) {
      this.registerForm.clearValidate();
    }
  }

  public handleSignUp() {
    this.exflag = true;
    if (this.loginForm) {
      this.loginForm.clearValidate();
    }
  }

  public handlePlatformUpgradeNotice() {
    const query: any = this.$route.query;
    // 直接转跳逻辑
    if(query.testData!=='1'||!query){
      redirectToGear3Login('');
    }
    // 弹窗转跳逻辑
    // if (query && query.showUpgradeNotice === '1') {
    //   return;
    // }
    // const targetUrl = getGear3LoginUrl('');
    // if (!targetUrl || getLoginUpgradeNoticeKey()) {
    //   return;
    // }
    // setLoginUpgradeNoticeKey('1');
    // this.platformUpgradeVisible = true;
  }

  public handleModifyPwd({ username }: any) {
    const forgetRef: any = this.$refs.forgetRef;
    forgetRef.form.email = username;
    forgetRef.form.newLoginPs = '';
    forgetRef.form.confirmPs = '';
    this.dialogVisible = true;
  }

  public registerToLogin() {
    this.exflag = false;
  }

    // 获取手机区号
  public async getPhoneRegion() {
    const { data } = await getPhoneRegionApi();
    this.phoneRegionOptions = data.datas;
  }

  public getCountryOptions(datas: any) {
    this.countryOptions = datas || [];
  }
}
